"use strict";

exports.__esModule = true;
exports.AgendaInfo = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactIntl = require("react-intl");
var _AgendaName = require("./AgendaName");
var _CalendarEventConfigInfo = require("../CalendarEvent/CalendarEventConfigInfo");
var _common = require("../../Device/common");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _dec, _class, _AgendaInfo;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var AgendaInfoWrapper = _styledComponents["default"].div.withConfig({
  displayName: "AgendaInfo__AgendaInfoWrapper",
  componentId: "sc-18bhf49-0"
})(["margin-top:1rem;padding-bottom:1rem;margin-bottom:1rem;border-bottom:1px solid rgba(0,0,0,0.1);"]);
var AgendaInfo = exports.AgendaInfo = (_dec = _DeviceListContext.DeviceListContext.withContext, _dec(_class = (_AgendaInfo = /*#__PURE__*/function (_Component) {
  function AgendaInfo() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(AgendaInfo, _Component);
  var _proto = AgendaInfo.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      agenda = _this$props.agenda,
      devices = _this$props.devices;
    return /*#__PURE__*/_react["default"].createElement(AgendaInfoWrapper, null, /*#__PURE__*/_react["default"].createElement("h4", null, /*#__PURE__*/_react["default"].createElement(_AgendaName.AgendaName, {
      agenda: agenda
    })), /*#__PURE__*/_react["default"].createElement("p", null, agenda.devices.length === 0 ? /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "AgendaInfo.plantAgendaSummary",
      defaultMessage: "This agenda applies to the entire plant."
    }) : /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "AgendaInfo.summary",
      defaultMessage: "\n              Agenda applies to {deviceCount, number} {deviceCount, plural,\n                      one {device}\n                      other {devices}\n                    }: {agendaDevices}\n            ",
      values: {
        deviceCount: agenda.devices.length,
        agendaDevices: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, agenda.devices.reduce(function (items, uuid, index, all) {
          var device = (0, _common.getDevice)(devices, uuid);
          var name = device ? device.name : uuid;
          items.push(/*#__PURE__*/_react["default"].createElement("strong", {
            key: uuid
          }, name));
          if (index !== all.length - 1) {
            items.push(", ");
          }
          return items;
        }, []))
      }
    })), /*#__PURE__*/_react["default"].createElement("ul", null, agenda.eventConfigs.map(function (eventConfig) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: eventConfig.id
      }, /*#__PURE__*/_react["default"].createElement(_CalendarEventConfigInfo.CalendarEventConfigInfo, {
        eventConfig: eventConfig
      }));
    })));
  };
  return AgendaInfo;
}(_react.Component), _AgendaInfo.defaultProps = {
  devices: undefined
}, _AgendaInfo)) || _class);